/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import {
    createAgency,
    getAllAgencies,
    getAgency,
    updateAgency,
    abandonAgency,
    reconcileSubscription,
} from './AgenciesService.core';
import {
    inviteAgencyMember,
    acceptAgencyInvite,
    changeUserRole,
    removeMemberFromAgency,
    getPendingInvitations,
    revokeInvitation,
    getAgencyInvitations,
} from './AgenciesService.members';
import {
    generateAgencyLogoUploadUrl,
    deleteAgencyLogo,
    getAgencyLogoViewUrl,
    getAgencyPermissions,
    updateAgencyPermissions,
} from './AgenciesService.logos';
import {
    getSubscriptionDetail,
    getAgencySeatUsage,
    getAgencySeatUsageHistory,
    cancelSubscription,
    revertCancellation,
    activateSubscriptionNow,
    changePlan,
    previewChangePlan,
    getSubscriptionInvoices,
    listSubscriptionAddons,
    purchaseSubscriptionAddon,
    createPaymentMethodSession,
} from './AgenciesService.subscription';
import {
    getAgencyTeam,
    inviteAgencyMembers,
    moveMemberSeat,
    changeSubscriptionItems,
    previewSubscriptionItems,
    setSubscriptionLeaving,
    validateCoupon,
    resendInvitation,
    invitationLink,
} from './AgenciesService.team';

export type {
    TeamOverview,
    TeamStorage,
    LeavingSeat,
    SubscriptionItemInput,
    ChangeItemsResult,
    CouponVerdictResponse,
    InvitationLinkResponse,
    SeatMoveResult,
    SeatMoveRefusal,
    TeamSeats,
    TeamSeatBlock,
    TeamPerson,
    TeamPendingInvite,
    TeamQuota,
    InviteEntry,
    InviteVerdict,
    InviteRefusal,
    InviteBatchResult,
} from './AgenciesService.team';

export type {
    SubscriptionDetail,
    InvoiceItem,
    InvoicesResponse,
    ChangePlanRequest,
    ChangePlanResponse,
    ChangePlanPreviewRequest,
    ChangePlanPreviewResponse,
    CancelSubscriptionResponse,
    AddonItem,
    PaymentMethodSessionResponse,
} from './AgenciesService.subscription';

/**
 * AgenciesService class.
 */
export class AgenciesService {
    public static createAgency = createAgency;
    public static getAllAgencies = getAllAgencies;
    public static getAgency = getAgency;
    public static updateAgency = updateAgency;
    public static abandonAgency = abandonAgency;
    public static reconcileSubscription = reconcileSubscription;

    public static inviteAgencyMember = inviteAgencyMember;
    public static acceptAgencyInvite = acceptAgencyInvite;
    public static changeUserRole = changeUserRole;
    public static removeMemberFromAgency = removeMemberFromAgency;
    public static getPendingInvitations = getPendingInvitations;
    public static revokeInvitation = revokeInvitation;
    public static getAgencyInvitations = getAgencyInvitations;

    public static generateAgencyLogoUploadUrl = generateAgencyLogoUploadUrl;
    public static deleteAgencyLogo = deleteAgencyLogo;
    public static getAgencyLogoViewUrl = getAgencyLogoViewUrl;
    public static getAgencyPermissions = getAgencyPermissions;
    public static updateAgencyPermissions = updateAgencyPermissions;

    public static getSubscriptionDetail = getSubscriptionDetail;
    public static getAgencySeatUsage = getAgencySeatUsage;
    public static getAgencySeatUsageHistory = getAgencySeatUsageHistory;
    public static cancelSubscription = cancelSubscription;
    public static revertCancellation = revertCancellation;
    public static activateSubscriptionNow = activateSubscriptionNow;
    public static changePlan = changePlan;
    public static previewChangePlan = previewChangePlan;
    public static getSubscriptionInvoices = getSubscriptionInvoices;
    public static listSubscriptionAddons = listSubscriptionAddons;
    public static purchaseSubscriptionAddon = purchaseSubscriptionAddon;
    public static createPaymentMethodSession = createPaymentMethodSession;

    public static getAgencyTeam = getAgencyTeam;
    public static inviteAgencyMembers = inviteAgencyMembers;
    public static moveMemberSeat = moveMemberSeat;
    public static changeSubscriptionItems = changeSubscriptionItems;
    public static previewSubscriptionItems = previewSubscriptionItems;
    public static setSubscriptionLeaving = setSubscriptionLeaving;
    public static validateCoupon = validateCoupon;
    public static resendInvitation = resendInvitation;
    public static invitationLink = invitationLink;
}
